import React, { forwardRef } from 'react';
import { IconsMap, FixedColorsIcons } from './iconsMap';
import { CustomTooltip } from '../Poppers';
import { DomUtils } from '../../utils/dom-utils';
import { WrapperElement } from './styled';
import { computeSize } from './utils';
import { Themes } from '../../style/theme-consts';

export const IconsWrapped = Object.entries(IconsMap).reduce((iconsMap, [key, Icon]) => {
  const IconWrapper = forwardRef(
    (
      { clickable, color, fill, stroke, disabled, fontSize, size, rotate, radiate, rotateCount, tooltip, ...rest },
      ref
    ) => {
      const iconProps = { ...(fill ? { fill } : {}), ...(stroke ? { stroke } : {}) };
      const fixedColor = !!FixedColorsIcons[key];
      const { theme, elementRef } = DomUtils.useDetectParentTheme(tooltip ? ref : null);
      ref = ref || (tooltip ? elementRef : null);

      const element = (
        <WrapperElement
          {...rest}
          data-testid={rest?.testId || rest?.['data-testid']}
          disabled={disabled}
          $fontSize={computeSize(size || fontSize)}
          $fixedColor={fixedColor}
          $clickable={clickable}
          $rotate={rotate}
          $rotateCount={rotateCount}
          ref={ref}
          $radiate={radiate}>
          <Icon color={color} {...iconProps} disabled={disabled} />
        </WrapperElement>
      );

      return tooltip ? (
        <CustomTooltip placement="bottom" title={tooltip} mode={theme || Themes.LIGHT} arrow={false}>
          {element}
        </CustomTooltip>
      ) : (
        element
      );
    }
  );
  return { ...iconsMap, [key]: IconWrapper };
}, {});

export const FixedColorIconsWrapped = Object.entries(FixedColorsIcons).reduce((iconsMap, [key, Icon]) => {
  const IconWrapper = ({
    clickable,
    fill,
    stroke,
    disabled,
    fontSize,
    size,
    rotate,
    radiate,
    rotateCount,
    ...rest
  }) => {
    const iconProps = { ...(fill ? { fill } : {}), ...(stroke ? { stroke } : {}) };

    return (
      <WrapperElement
        {...rest}
        disabled={disabled}
        data-testid={rest?.testId || rest?.['data-testid']}
        $fontSize={computeSize(size || fontSize)}
        $clickable={clickable}
        $fixedColor
        $rotate={rotate}
        $rotateCount={rotateCount}
        $radiate={radiate}>
        <Icon {...iconProps} disabled={disabled} />
      </WrapperElement>
    );
  };
  return { ...iconsMap, [key]: IconWrapper };
}, {});
